// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"2ed0bf94","990":"90d49e8a"}[chunkId] + ".chunk.js";
};